import { render, staticRenderFns } from "./LayoutsCombinigAssetsSection.vue?vue&type=template&id=49089bd8"
import script from "./LayoutsCombinigAssetsSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsCombinigAssetsSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsCombinigAssetsSection.vue?vue&type=style&index=0&id=49089bd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports